export default __webpack_public_path__ + "static/media/photo2.eada07e9.png";